import auth from '@/core/lib/new-architecture/api/auth.api';
import badges from '@/core/lib/new-architecture/api/badges.api';
import categories from '@/core/lib/new-architecture/api/categories.api';
import contactsDonations from '@/core/lib/new-architecture/api/contactsDonations.api';
import conversation from '@/core/lib/new-architecture/api/conversation.api';
import conversations from '@/core/lib/new-architecture/api/conversations.api';
import documents from '@/core/lib/new-architecture/api/documents.api';
import donation from '@/core/lib/new-architecture/api/donation.api';
import donations from '@/core/lib/new-architecture/api/donations.api';
import donationsUserSearch from '@/core/lib/new-architecture/api/donationsUserSearch.api';
import featureFlag from '@/core/lib/new-architecture/api/featureFlag.api';
import followedDonations from '@/core/lib/new-architecture/api/followedDonations.api';
import home from '@/core/lib/new-architecture/api/home.api';
import interests from '@/core/lib/new-architecture/api/interests.api';
import locs from '@/core/lib/new-architecture/api/locs.api';
import push from '@/core/lib/new-architecture/api/push.api';
import report from '@/core/lib/new-architecture/api/report.api';
import savedSearch from '@/core/lib/new-architecture/api/savedSearch';
import stripe from '@/core/lib/new-architecture/api/stripe.api';
import user from '@/core/lib/new-architecture/api/user.api';
import userDonation from '@/core/lib/new-architecture/api/user.donation.api';
import userDonations from '@/core/lib/new-architecture/api/user.donations.api';

const Api = {
  query: {
    donation: donation.query,
    donations: donations.query,
    followedDonations: followedDonations.query,
    categories: categories.query,
    badges: badges.query,
    interests: interests.query,
    user: {
      ...user.query,
      donation: userDonation.query,
      donations: userDonations.query,
    },
    locs: locs.query,
    documents: documents.query,
    conversations: conversations.query,
    conversation: conversation.query,
    savedSearch: savedSearch.query,
    contactDonations: contactsDonations.query,
    home: home.query,
    featureFlag: featureFlag.featureFlagQuery,
    donationsUserSearchApi: donationsUserSearch.donationsUserSearchQuery,
    stripe: stripe.query,
  },
  mutation: {
    donation: donation.mutation,
    auth: auth.mutation,
    push: push.mutation,
    user: user.mutation,
    savedSearch: savedSearch.mutation,
    donationsUserSearchApi: donationsUserSearch.mutation,
    locs: locs.mutation,
    conversation: conversation.mutation,
    conversations: conversations.mutation,
    report: report.mutation,
    stripe: stripe.mutation,
  },
};

export default Api;
